module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b042d172da3763f5f2a58bd8cb80dae7.gif";